import log from 'loglevel';

const isProd = process.env.NODE_ENV === 'production';

const logger = {
  trace: (...args) => log.trace('[TRACE]', ...args),
  debug: (...args) => log.debug('[DEBUG]', ...args),
  info: (...args) => log.info('[INFO]', ...args),
  warn: (...args) => log.warn('[WARN]', ...args),
  error: (...args) => log.error('[ERROR]', ...args),
  setLevel: (level) => log.setLevel(level),
};

logger.setLevel(isProd ? 'warn' : 'debug');

export default logger;
